import React, { useEffect, useRef } from "react";
import { IMAGES } from "../../data/mock";
import { Flame } from "lucide-react";

export default function ForgeInterlude() {
  const wrap = useRef(null);
  useEffect(() => {
    const el = wrap.current; if (!el) return;
    const on = () => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > window.innerHeight + 100) return;
      const img = el.querySelector(".fi-img");
      const text = el.querySelector(".fi-text");
      const p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
      if (img) img.style.transform = `translate3d(0, ${(p - 0.5) * 90}px, 0) scale(1.14)`;
      if (text) text.style.transform = `translate3d(0, ${(p - 0.5) * -30}px, 0)`;
    };
    window.addEventListener("scroll", on); on();
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <section ref={wrap} className="relative h-[90vh] md:h-[100vh] overflow-hidden border-b hairline">
      <div className="absolute inset-0 fi-img will-change-transform">
        <img src={IMAGES.forgeHammer} alt="Forged in fire" className="w-full h-full object-cover" />
      </div>
      {/* Vignette + heat */}
      <div className="absolute inset-0" style={{ background: "radial-gradient(900px 600px at 60% 60%, rgba(201,114,42,0.18), transparent 60%), linear-gradient(180deg, rgba(10,9,8,0.6) 0%, rgba(10,9,8,0.55) 40%, rgba(10,9,8,0.92) 100%)" }}></div>
      {/* Scanning light */}
      <div className="absolute inset-0 pointer-events-none opacity-40 mix-blend-screen" style={{ background: "linear-gradient(180deg, transparent 30%, rgba(240,166,99,0.15) 50%, transparent 70%)" }}></div>

      <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col justify-end pb-16 md:pb-24 fi-text">
        <div className="flex items-center gap-3 text-[var(--ember-3)] mb-6">
          <Flame size={16} />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em]">— The Forge —</span>
        </div>
        <h3 className="font-display text-[52px] md:text-[130px] leading-[0.9] tracking-[-0.035em] max-w-[1100px]">
          Steel is made <span className="italic-serif text-[var(--ember-3)]">tender</span><br />before it is made strong.
        </h3>
        <p className="mt-10 max-w-[560px] text-[var(--text-muted)] text-[16.5px] leading-[1.75]">
          The forge doesn't ask if you are ready. It asks if you will stay. Discipline, repentance, prayer, iron. The man is made in the heat — not in the mirror.
        </p>
      </div>
    </section>
  );
}
